import React from "react";
import "./gridView.css";
import { useSelector } from "react-redux";

export default function GridView() {
  const gridInfo = useSelector((state) => state.grid);
  const roofInfo = useSelector((state) => state.roof)

  const pixelValue = roofInfo?.value?.pixelValue? roofInfo.value.pixelValue : 15
  

  const column = gridInfo.column * (gridInfo.zoom / pixelValue)
  const row = gridInfo.row * (gridInfo.zoom / pixelValue)
   

  return (
    <>
      <div className="gridView">
        <div className="widthParameter">
          <div className="leftSide">
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
            <span className="line"></span>
          </div>
          <span className="text">{gridInfo.unit === "ft" ? (column.toFixed(0)) : ((column / 3.28084).toFixed(0))}{gridInfo.unit}</span>
          <div className="rightSide">
            <span className="line"></span>
            <span>
              <i className="bi bi-chevron-right"></i>
            </span>
          </div>
        </div>
        <div className="heightParameter">
          <div className="leftSide">
          <span>
              <i className="bi bi-chevron-up"></i>
            </span>
          <span className="line"></span>
            
          </div>
          <span className="text">{gridInfo.unit === "ft" ? (row.toFixed(0)) : ((row / 3.28084).toFixed(0))}{gridInfo.unit}</span>
          <div className="rightSide">
            
            <span className="line"></span>
            <span>
              <i className="bi bi-chevron-down"></i>
            </span>
          </div>
        </div>
        {[...Array(gridInfo.column)].map((r, rowIndex) => (
          <div
            key={rowIndex}
            className="row"
            style={{ width: `${gridInfo.zoom}px` }}
          >
            {[...Array(gridInfo.row)].map((col, colIndex) => (
              <span
                key={colIndex}
                className="block"
                style={{
                  width: `${gridInfo.zoom}px`,
                  height: `${gridInfo.zoom}px`,
                }}
              ></span>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}
